<template>
  <div class="rootGrid">
    <div
      class="backdrop"
      v-show="visible"
      :style="{width: Window_Size.width + 'px',height: Window_Size.height + 'px'}"
      @click.stop="dialogOnClick()"
      @mousedown.stop
    ></div>
    <transition name="el-fade-in">
      <div
        class="main"
        v-show="visible"
        :style="{width: dialogSize.width + 'px',height: dialogSize.height + 'px', left: dialogSize.left + 'px', top: dialogSize.top + 'px'}"
      >
        <!--左侧-->
        <div class="left-area">
          <div class="top-title">
            <span>模板素材库</span>
          </div>
          <!--菜单栏-->
          <div class="menu-layout">
            <el-menu :default-active="activeIndex" @select="selectChange">
              <el-menu-item index="1">
                <span slot="title">模板</span>
              </el-menu-item>
              <el-menu-item index="2">
                <span slot="title">场景</span>
              </el-menu-item>
              <el-menu-item index="3">
                <span slot="title">背景</span>
              </el-menu-item>
              <el-menu-item index="4">
                <span slot="title">文字</span>
              </el-menu-item>
              <el-menu-item index="5">
                <span slot="title">角色</span>
              </el-menu-item>
              <el-menu-item index="6">
                <span slot="title">素材</span>
              </el-menu-item>
              <el-menu-item index="7">
                <span slot="title">声音</span>
              </el-menu-item>
              <!-- <el-menu-item index="1">
                <span slot="title">场景</span>
              </el-menu-item>
              <el-menu-item index="2">
                <span slot="title">背景</span>
              </el-menu-item>
              <el-menu-item index="3">
                <span slot="title">文字</span>
              </el-menu-item>
              <el-menu-item index="4">
                <span slot="title">角色</span>
              </el-menu-item>
              <el-menu-item index="5">
                <span slot="title">道具</span>
              </el-menu-item>
              <el-menu-item index="6">
                <span slot="title">声音</span>
              </el-menu-item> -->
            </el-menu>
          </div>
        </div>
        <!--右侧内容区域-->
        <div class="content-area" :style="{width:dialogSize.width-160 + 'px'}">
          <!--数据展示区-->
          <div class="data-content">
            <keep-alive>
              <component ref="contentPage" :is="getView"></component>
            </keep-alive>
          </div>
        </div>
        <transition name="el-fade-in">
          <div class="templib-usetemp-subwin" v-if="tempSubwinItem.id">
            <templateUse :template="tempSubwinItem"></templateUse>
          </div>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import templateContent from "./contents/template/templateContent";
import sceneContent from "./contents/sceneContent";
import backgroundContent from "./contents/background/backgroundContent";
import textContent from "./contents/textContent";
import rolesContent from "./contents/rolesContent";
import propsContent from "./contents/propsContent";
import musicContent from "./contents/musicContent";
import templateUse from "./contents/template/templateUse";
export default {
  name: "templateMaterialLibDialog",
  data() {
    return {
      activeIndex: "1",
      tabViews: [
        { name: "template", view: "templateContent" },
        { name: "scene", view: "sceneContent" },
        { name: "background", view: "backgroundContent" },
        { name: "text", view: "textContent" },
        { name: "roles", view: "rolesContent" },
        { name: "props", view: "propsContent" },
        { name: "music", view: "musicContent" }
      ],
      tempSubwinItem: {},
      PageType: ""
    };
  },
  props: {
    visible: Boolean
  },
  components: {
    sceneContent,
    templateContent,
    backgroundContent,
    textContent,
    rolesContent,
    propsContent,
    musicContent,
    templateUse
  },
  computed: {
    ...mapGetters(["Window_Size", "MaterialLib_Nav_Param", "TOOL", "StyleMsg"]),
    dialogSize() {
      let width = Math.min(1226, this.Window_Size.width - 50);
      let height = Math.min(708, this.Window_Size.height - 50);
      let left = (this.Window_Size.width - width) / 2;
      let top = (this.Window_Size.height - height) / 2;
      return {
        width,
        height,
        left,
        top
      };
    },
    getView() {
      if (this.PageType == "template") {
        this.activeIndex = "1";
        return this.tabViews[0].view;
      } else if (this.PageType == "scene") {
        this.activeIndex = "2";
        return this.tabViews[1].view;
      } else if (this.PageType == "background") {
        this.activeIndex = "3";
        return this.tabViews[2].view;
      } else if (this.PageType == "text") {
        this.activeIndex = "4";
        return this.tabViews[3].view;
      } else if (this.PageType == "roles") {
        this.activeIndex = "5";
        return this.tabViews[4].view;
      } else if (this.PageType == "props") {
        this.activeIndex = "6";
        return this.tabViews[5].view;
      } else if (this.PageType == "music") {
        this.activeIndex = "7";
        return this.tabViews[6].view;
      } else {
        // this.activeIndex = "1";
        // return this.tabViews[0].view;
      }
    }
    // getView() {
    //   if (this.PageType == "scene") {
    //     this.activeIndex = "1";
    //     return this.tabViews[0].view;
    //   } else if (this.PageType == "background") {
    //     this.activeIndex = "2";
    //     return this.tabViews[1].view;
    //   } else if (this.PageType == "text") {
    //     this.activeIndex = "3";
    //     return this.tabViews[2].view;
    //   } else if (this.PageType == "roles") {
    //     this.activeIndex = "4";
    //     return this.tabViews[3].view;
    //   } else if (this.PageType == "props") {
    //     this.activeIndex = "5";
    //     return this.tabViews[4].view;
    //   } else if (this.PageType == "music") {
    //     this.activeIndex = "6";
    //     return this.tabViews[5].view;
    //   } else {
    //     // this.activeIndex = "1";
    //     // return this.tabViews[0].view;
    //   }
    // }
  },
  methods: {
    dialogOnClick() {},
    selectChange(key, keyPath) {
      //console.log("selectChange", key, keyPath);
      this.PageType = this.tabViews[key - 1].name;
      this.switchPage();
    },
    activePage() {
      this.$nextTick(() => {
        this.$refs.contentPage.activePage(this.MaterialLib_Nav_Param.navParam);
      });
    },
    switchPage() {
      this.$nextTick(() => {
        this.$refs.contentPage.activePage();
      });
    }
  },
  watch: {
    MaterialLib_Nav_Param: function(val, oldval) {
      if (val) {
        this.PageType = val.materialType;
        this.activePage();
      } else {
        this.PageType == "template";
      }
    }
  },
  mounted() {
    this.$bus.on("templib-tempuse-isopen", data => {
      if (data.id) {
        this.tempSubwinItem = data;
      } else {
        this.tempSubwinItem = {};
      }
    });
  }
};
</script>

<style scoped lang="scss" >
.rootGrid {
  background-color: #474261;
}

.backdrop {
  position: absolute;
  top: 0;
  left: 0;
  /* background-color: rgba(#39393C, .8);; */
  background-color: rgba(71, 71, 74, 0.8);
}

.main {
  position: relative;
  top: 25px;
  left: 44px;
  background-color: transparent;
  box-shadow: 0px 0px 4px 0px rgba(54, 76, 204, 0.4);
  border-radius: 8px;
  border: 0px solid white;
  overflow: hidden;
}

#closeBtn {
  margin: 0px;
}

.menu-layout {
  float: left;
  width: 160px;
  height: 100%;
  /deep/ .el-menu {
    border-right: 0px;
    background-color: #d9ddea;
    .el-menu-item.is-active {
      background-color: #fff;
    }
  }
}
.search-bar {
  position: absolute;
  width: 1000px;
  float: right;
  right: 50px;
}

.left-area {
  position: relative;
  background-color: #d9ddea;
  height: 100%;
  width: 160px;
  float: left;
  .top-title {
    width: 160px;
    height: 50px;
    justify-content: center;
    font-size: 16px;
    font-weight: bold;
    color: #474261;
    border-bottom: solid 1px #f0f0f8;
    padding: 13px 0 0 0;
  }
  .uploadbtn {
    position: absolute;
    width: 120px;
    height: 38px;
    background-color: #5778fb;
    border-radius: 19px;
    .icon {
      float: left;
      width: 16px;
      height: 16px;
    }
  }
}

.content-area {
  overflow: hidden;
  //border-radius: 0 0 8px 0px;
  position: relative;
  width: 100%;
  height: 100%;
  float: left;
  background-color: lightgray;
}

.data-content {
  position: relative;
  float: left;
  height: 100%;
  width: 100%;
  background-color: gray;
}

//使用模板弹窗
.templib-usetemp-subwin {
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/templateLib/templateMaterialLibDialog.vue